import { render, staticRenderFns } from "./ArrowDown.vue?vue&type=template&id=2efe0c68&scoped=true"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"
import style0 from "./ArrowDown.vue?vue&type=style&index=0&id=2efe0c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efe0c68",
  null
  
)

export default component.exports